import React, { useState } from 'react';
import cx from 'classnames';

import ProductCard, { ProductCardProps } from '../ProductCard';
import AddToCartButton from '../AddToCartButton';

import styles from './index.module.scss';

export interface ProductCardListProps {
  list: ProductCardProps[];
  className?: string;
  isSingleSelect?: boolean;
  urlAttributes?: string;
  isLocked?: boolean;
}

const ProductCardList: React.FC<ProductCardListProps> = ({
  list,
  className,
  isSingleSelect,
  urlAttributes,
  isLocked,
}) => {
  const isListWithOnlyOneItem = list && list.length === 1;
  // if there is only one product, preselect it, else start with empty selection
  const getSingleProductVariantId = (list: ProductCardProps[]) =>
    isListWithOnlyOneItem ? list.map((item) => item.variantId) : [];

  const [selectedProductsVariantIds, setSelectedProductsVariantIds] = useState(
    getSingleProductVariantId(list),
  );

  const handleProductToggle = (variantId: string) => {
    if (isSingleSelect) {
      setSelectedProductsVariantIds((prevIds) =>
        prevIds.includes(variantId) ? [] : [variantId],
      );
    } else {
      setSelectedProductsVariantIds((prevIds) =>
        prevIds.includes(variantId)
          ? prevIds.filter((id) => id !== variantId)
          : [...prevIds, variantId],
      );
    }
  };

  return (
    list &&
    list.length > 0 && (
      <div className={cx(styles.wrapper, className)}>
        <div className={styles.listWrapper}>
          {list.map((item, index) => (
            <ProductCard
              key={index}
              {...item}
              className={styles.card}
              contentClassName={cx({
                [styles.multipleProducts]: item.isMultipleProducts,
              })}
              isChecked={selectedProductsVariantIds.includes(item.variantId)}
              onToggle={handleProductToggle}
              isMultipleProducts={!isListWithOnlyOneItem}
              isLocked={isLocked}
            />
          ))}
        </div>
        <AddToCartButton
          selectedProducts={selectedProductsVariantIds}
          isOnlyOneProduct={list.length === 1}
          urlAttributes={urlAttributes}
        />
      </div>
    )
  );
};

export default ProductCardList;
